<template>
    <q-card class="q-pa-md q-ma-md rounded-borders shadow-2" flat>
        <q-card-section v-if="loadingInformation">
            <q-spinner color="primary" size="30px" class="q-mt-md" />
        </q-card-section>

        <div v-else>
            <q-card-section>
            <div class="text-h6">{{ person.first_name }} {{ person.last_name }}</div>
        </q-card-section>

        <q-separator />

        <q-card-section class="q-gutter-sm">
            <q-item-label><strong>Gender:</strong> {{ person.gender_id }}</q-item-label>
            <q-item-label><strong>Age:</strong> {{ person.age }}</q-item-label>
            <q-item-label><strong>Ethnicity:</strong> {{ person.ethnicity_id }}</q-item-label>
            <q-item-label><strong>Iwi:</strong> {{ person.iwi_id }}</q-item-label>
        </q-card-section>

        <q-separator />

        <q-card-section class="q-gutter-sm">
            <q-item-label><strong>Active Programmes:</strong> {{ person.programmes }}</q-item-label>
            <q-item-label><strong>Active Services:</strong> {{ person.services || 'None' }}</q-item-label>
        </q-card-section>
        
        <q-separator />

        <q-card-section class="q-gutter-sm">
            <q-item-label><strong>Exited Programmes:</strong> {{ person.exited_programmes || 'None' }}</q-item-label>
            <q-item-label><strong>Exited Services:</strong> {{ person.exited_services || 'None' }}</q-item-label>
        </q-card-section>

        <q-separator />

        <q-card-section class="q-gutter-sm">
            <q-item-label><strong>Active Primary Workers:</strong> {{ person.active_primary_workers || 'None' }}</q-item-label>
            <q-item-label><strong>Historic Primary Workers:</strong> {{ person.historic_primary_workers || 'None' }}</q-item-label>
        </q-card-section>
        </div>
    </q-card>
</template>

<script>

import api from "../../../services/api/api"
import notify from '@/services/util/notify';

export default {
    name: "ActivePersonProfileComponent",

    props: {
        personId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            person: {},
            loadingInformation: false,
        }
    },

    async created() {
        await this.retrievePersonInformation();
    },

    methods: {
        async retrievePersonInformation() {
            this.loadingInformation = true;
            await api.client.getPersonProfile(this.personId).then((res) => {
                this.person = res.data;
            }).catch((error) => {
                notify.error(error.message, 'top');
            }).finally(() => {
                this.loadingInformation = false;
            });
        },
    }
}
</script>
